export class ProblemToken{
    constructor(private _probHeader:string,private _description:string,private _probId:string, 
        private _startTime:number,private _endTime:number,private _status:string){

    }
    get header():string{
        return this._probHeader;
    }
    get description():string{
        return this._description;
    }
    get id():string{
        return this._probId;
    }
    get startTime():number{
        return this._startTime;
    }
    get endTime():number{
        return this._endTime;
    }
    getViewingDate(_srchFromDate:Date,_srchToDate:Date):number{
        if(this._status == "close"){
            return this._endTime;
        }
        else{
            var _currDate = new Date();
            if(_currDate > _srchFromDate && _currDate < _srchToDate){
                return _currDate.getTime();
            }
            // else if(_currDate > _srchToDate){
            //     return _srchToDate.getTime();
            // }
        }
        return null;
    }
    get status():string{
        return this._status;
    }

}